/* LOCAL STORAGE KEYS */

export const LS_OPERATIONS_ALL_EVENTS_TOURNAMENTS_FILTERS_KEY =
  '/operations/all-events-tournaments/filters';

export const LS_OPERATIONS_PREMATCH_EVENTS_TOURNAMENTS_FILTERS_KEY =
  '/operations/prematch-events-tournaments/filters';

export const LS_OPERATIONS_LIVE_EVENTS_TOURNAMENTS_FILTERS_KEY =
  '/operations/live-events-tournaments/filters';

export const LS_OPERATIONS_ALL_OFFER_TEMPLATE_EVENTS_TOURNAMENTS_FILTERS_KEY =
  '/operations/all-offer-template-events-tournaments/filters';

export const LS_OPERATIONS_PREMATCH_OFFER_TEMPLATE_EVENTS_TOURNAMENTS_FILTERS_KEY =
  '/operations/prematch-offer-template-events-tournaments/filters';

export const LS_OPERATIONS_LIVE_OFFER_TEMPLATE_EVENTS_TOURNAMENTS_FILTERS_KEY =
  '/operations/live-offer-template-events-tournaments/filters';

export const LS_OPERATIONS_PROMOTED_OFFER_FILTERS_KEY = '/operations/promoted-offer/filters';

export const LS_OPERATIONS_PROMOTED_OFFER_LAYOUT_FILTERS_KEY =
  '/operations/promoted-offer-layout/filters';

export const LS_OPERATIONS_RECOMMENDED_BETSLIP_FILTERS_KEY =
  '/operations/recommended-betslip/filters';

export const LS_OPERATIONS_RECOMMENDED_BETSLIP_GROUP_FILTERS_KEY =
  '/operations/recommended-betslip-group/filters';

export const LS_OPERATIONS_DISPLAY_TEMPATES_FILTERS_KEY = '/operations/display-templates/filters';

export const LS_OPERATIONS_FEED_RECOVERY_FILTERS_KEY = '/operations/feed-recovery/filters';

export const LS_OPERATIONS_TICKET_AUTHORIZATION_CURRENCY_KEY =
  '/operations/ticket-authorization/currency';

export const LS_SETTINGS_SPORTS_FILTERS_KEY = '/settings/sports/filters';
export const LS_SETTINGS_OFFER_TEMPLATE_FILTERS_KEY = '/settings/offer-template/filters';
export const LS_SETTINGS_CATEGORIES_FILTERS_KEY = '/settings/categories/filters';
export const LS_SETTINGS_MARKETS_FILTERS_KEY = '/settings/markets/filters';
export const LS_SETTINGS_TOURNAMENTS_FILTERS_KEY = '/settings/tournaments/filters';
export const LS_SETTINGS_TOURNAMENT_ROUNDS_FILTERS_KEY = '/settings/tournament-rounds/filters';
export const LS_SETTINGS_OUTCOMES_FILTERS_KEY = '/settings/outcomes/filters';
export const LS_SETTINGS_TEAMS_FILTERS_KEY = '/settings/teams/filters';
export const LS_SETTINGS_PLAYERS_FILTERS_KEY = '/settings/players/filters';
export const LS_SETTINGS_MARKET_GROUPS_FILTERS_KEY = '/settings/market-groups/filters';
export const LS_SETTINGS_OFFER_LAYOUT_FILTERS_KEY = 'settings/offer-layout/filters';

export const LS_SETTINGS_RESULTS_FILTERS_KEY = '/settings/results/filters';

export const LS_SETTINGS_RESOLVE_FORMULA_FILTERS_KEY = '/settings/resolve-formula/filters';
export const LS_SETTINGS_RESOLVE_FORMULA_TIER_FILTERS_KEY =
  '/settings/resolve-formula-tier/filters';
export const LS_SETTINGS_RESOLVE_FORMULA_SET_FILTERS_KEY = '/settings/resolve-formula-set/filters';
export const LS_SETTINGS_MARKET_OUTCOME_RESOLVE_FORMULA_SET_FILTERS_KEY =
  '/settings/market-outcome-resolve-formula-set/filters';
export const LS_SETTINGS_OUTCOME_ASSIGNMENT_FILTERS_KEY = '/settings/outcome-assignment/filters';

export const LS_SETTINGS_BETS_FILTERS_KEY = '/operations/bets/filters';
export const LS_SETTINGS_BET_SELECTIONS_FILTERS_KEY = '/operations/bets/selections';

export const LS_SETTINGS_EVENT_RESULTS_FILTERS_KEY = '/operations/event-results/filters';
export const LS_SETTINGS_LIABILITY_MONITORING_FILTERS_KEY =
  '/operations/liability-monitoring/filters';

export const LS_SETTINGS_SELECTIONS_AUTOMATIZATION_FILTERS_KEY =
  '/settings/selections-automatization/filters';

export const LS_SETTINGS_TIMELINES_FILTERS_KEY = '/settings/timelines/filters';
export const LS_SETTINGS_PROMOTED_OFFER_FILTERS_KEY = '/settings/promoted-offer/filters';

export const LS_SETTINGS_PROMOTED_CATALOGUE_FILTERS_KEY = '/settings/promoted-catalogue/filters';

export const LS_OPERATIONS_FEED_MAPPING_EVENTS_1_FILTERS_KEY =
  '/operations/feed-mapping/events-1/filters';
export const LS_OPERATIONS_FEED_MAPPING_EVENTS_2_FILTERS_KEY =
  '/operations/feed-mapping/events-2/filters';

export const LS_SETTINGS_LIABILITY_KEY = '/settings/liability';
export const LS_SETTINGS_LIABILITY_TEMPLATES_KEY = '/settings/liability-templates';

export const LS_SETTINGS_LIMIT_GROUPS_FILTERS_KEY = '/settings/limits/limit-groups';
export const LS_SETTINGS_LIMIT_GROUP_COLLECTIONS_FILTERS_KEY =
  '/settings/limits/limit-group-collections';

export const LS_SETTINGS_BET_TARGETS_FILTERS_KEY = '/settings/limits/bet-targets';

export const LS_SETTINGS_SCHEME_TYPES_FILTERS_KEY = '/settings/odds-scheme/scheme-type/filters';
export const LS_SETTINGS_SCHEME_INSTANCES_FILTERS_KEY =
  '/settings/odds-scheme/odds-scheme-instances/filters';
export const LS_SETTINGS_SCHEME_SCHEME_FEED_AND_AUTOIMPORTS_FILTERS_KEY =
  '/settings/odds-scheme/scheme-feed-and-autoimport-config/filters';
export const LS_SETTINGS_SCHEME_SPORT_ASSIGNMENT_FILTERS_KEY =
  '/settings/odds-scheme/sport-assignment/filters';
export const LS_SETTINGS_SCHEME_TOURNAMENT_ASSIGNMENT_FILTERS_KEY =
  '/settings/odds-scheme/tournament-assignment/filters';

/* INJECTION KEYS */

export const tenantDataKey = Symbol('tenantData');
export const translationsKey = Symbol('translations');
export const languageCodesKey = Symbol('languageCodes');
export const tenantsListKey = Symbol('tenantsList');
export const marketSpecifierTypesKey = Symbol('marketSpecifierTypes');
export const tenantChildrenKey = Symbol('tenantChildren');

/* APP DEFAULT VALUES */
export const DEFAULT_EVENTS_DATE_RANGE = 7;
export const DEFAULT_RESULTS_DATE_RANGE = 0;

/* HEADER THEME COLORS */
export const headerBgColors = {
  dark: '#2f3742',
  red: '#7A1C1C',
  green: '#1E4D2B',
  graphite: '#263238',
  orange: '#8C3D00',
  yellow: '#6D5C00',
  plum: '#4B286D',
};
